import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { EmptyinputformComponent } from './emptyinputform/emptyinputform.component';
import { AddressformsampleComponent } from './addressformsample/addressformsample.component';
import { TablesampleComponent } from './tablesample/tablesample.component';
import { NavigationsampleComponent } from './navigationsample/navigationsample.component';
import { DashboardsampleComponent } from './dashboardsample/dashboardsample.component';
import { TreesampleComponent } from './treesample/treesample.component';

const routes: Routes = [
  { path: 'emptyinputform', component: EmptyinputformComponent },
  { path: 'addressformsample', component: AddressformsampleComponent },
  { path: 'tablesample', component: TablesampleComponent },
  { path: 'navigationsample', component: NavigationsampleComponent },
  { path: 'dashboardsample', component: DashboardsampleComponent },
  { path: 'treesample', component: TreesampleComponent }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
